import { BehaviorSubject } from "rxjs";

export const currentUserSubject = new BehaviorSubject(
  JSON.parse(localStorage.getItem("currentUser"))
);

// export const api_endpoint = "http://localhost:8081/api";
export const api_endpoint = "https://dwra169.upsquare.in/api";
